const messages = {
  title: "Prodajne promocije",
  desc: "Aktivno koristite naše prodajne promocije sa vašim klijentima. Naravno, možete ponuditi klijentima obje promocije. Pročitajte više o Garanciji guma i Drive Our Best u nastavku.",
  participation: {
    title: "Zatražite vaše učestvovanje sada",
    desc: "Da li biste željeli implementirati jednu ili više naših promocija u vašoj trgovini? Tada možete zatražiti ovdje vaše učestvovanje. Vaša kompanija će biti aktivirana za promocije i primit će promotivne materijale u roku od 4 nedjelje za vašu prodajnu kampanju.<br/><br/>Napravite vaš izbor:",
    request: "ZATRAŽI UČESTVOVANJE",
    success: "Hvala vam, vaš zahtjev je poslan",
  },
};
export default {
  messages,
};
